import React, { useEffect } from 'react';

var ClassicChat = function ClassicChat(props) {
  useEffect(function () {
    var chatScript = document.createElement('script');
    chatScript.setAttribute('src', 'https://caretech-assets.care.vpsvc.com/js/classicChat.js');

    chatScript.onload = function () {
      var onlineElements = [];
      var offlineElements = [];
      props.onlineElementIds ? props.onlineElementIds.forEach(function (val, index) {
        return onlineElements.push(props.onlineElementIds[index]);
      }) : undefined;
      props.offlineElementIds ? props.offlineElementIds.forEach(function (val, index) {
        return offlineElements.push(props.offlineElementIds[index]);
      }) : undefined;

      if (window && props.startChatElement != undefined && props.locale != undefined && props.tenant != undefined) {
        window['initChat'](props.tenant, props.locale, props.startChatElement, onlineElements, offlineElements, props.loader, props.requestor, props.feature, props.segmentKey, props.userDetails);
      }
    };

    document.body.appendChild(chatScript);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export { ClassicChat };
//# sourceMappingURL=index.es.js.map
